const overlay = require('./_overlay')
/*************************************************************************************
* moduleName
*************************************************************************************/
const open = function() {
    // overlay.open()
    $('.mobileNav').addClass('mobileNav-active');
    $('.gHeader_spMenuIcon').addClass('gHeader_spMenuIcon-active');
    $(".gHeader_logo a img").attr("src",$(".gHeader_logo a img").attr("src").replace(/^(.+)(\.[a-zA-Z]+)$/, "/assets/images/global/logo-sp.png"));
}

const close = function() {
    // overlay.close()
    $('.mobileNav').removeClass('mobileNav-active');
    $('.gHeader_spMenuIcon').removeClass('gHeader_spMenuIcon-active');
    $(".gHeader_logo a img").attr("src",$(".gHeader_logo a img").attr("src").replace(/^(.+)(\.[a-zA-Z]+)$/, "/assets/images/global/logo.png"));
    $(".gHeader").removeClass("gHeader-up");

}

const toggle = function(){
	$('.mobileNav').hasClass('mobileNav-active') ? close() : open();
}

const setActive = function() {
    close()
    $('.gNav_item-active').removeClass('gNav_item-active')
	$(this).closest('.mobileNav_item').addClass('gNav_item-active')
}

module.exports = {
    open,
    close,
    toggle,
    setActive,
}

jQuery(function() {
    //PC
    var ww = jQuery('body').width();
    if (ww >= 736) {
      $(function() {
        let pos = 0;
        $(window).on('scroll', function () {
          const $header = $('.gHeader');
          const $main = $('main');
          const headerHeight = $header.outerHeight() + 70;
          const currentPos = $(this).scrollTop(); // スクロール量
          // スクロール量がヘッダーの高さより大きい場合
          if (currentPos > headerHeight) {
            // headerを固定
            $header.addClass('gHeader-up');
            $main.css('margin-top', headerHeight);
          } else {
            // それ以外は固定を解除
            $header.removeClass('gHeader-up');
            $main.css('margin-top', 0);
          }
      
          // 上スクロール時
          if (currentPos < pos) {
            // header引っ込める
            $header.css('top', 0);
          } 
          else {
            //下スクロール時はheader出す
            $header.css('top', -headerHeight);
          }
          pos = currentPos;
        });
    });
    }
   
    //SP
    if (ww < 736) {
  
    }
  });